import React from 'react';
import { useParams } from 'react-router-dom';
import EquipmentPage from '../../components/EquipmentPage';
import { equipmentData } from '../../data/tecnal';

const EquipmentPageWrapper = () => {
  const { category, equipment } = useParams();
  
  // Build the key to lookup in equipmentData
  const dataKey = `${category}/${equipment}`;
  const data = equipmentData[dataKey];
  
  if (!data) {
    return (
      <div className="not-found-page" style={{ padding: '4rem', textAlign: 'center' }}>
        <h1>Equipo no encontrado</h1>
        <p>El equipo que busca no está disponible.</p>
      </div>
    );
  }
  
  return <EquipmentPage data={data} />;
};

export default EquipmentPageWrapper;
